export default "__VITE_ASSET__CgDw1dEq__"